import { render, staticRenderFns } from "./Tsys.vue?vue&type=template&id=4a6b965e&"
import script from "./Tsys.vue?vue&type=script&lang=js&"
export * from "./Tsys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports